import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overlay-loading"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingOverlay',
  props: {
    visible: { type: Boolean },
    message: {}
  },
  setup(__props: any) {

/**
 * Capa de carga que bloquea la interacción durante una operación larga.
 *
 * Relevante porque varias operaciones del sistema (informes, sincronización de
 * formularios) tardan decenas de segundos.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props

return (_ctx: any,_cache: any) => {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "spinner" }, null, -1)),
        _createElementVNode("p", null, _toDisplayString(_ctx.message), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})